import type { OnboardingGoal } from '@alexiarest/shared';

export function GoalChoices({ value, onChange, disabled = false }: {
  value?: OnboardingGoal; onChange: (value: OnboardingGoal) => void; disabled?: boolean;
}): JSX.Element {
  return <fieldset className="goal-choices" disabled={disabled}>
    <legend>¿Qué quieres lograr primero?</legend>
    <div className="goal-choices__grid">
      {([
        ['costs', 'Saber qué me cuesta cada plato', 'Empieza por tu plato estrella y descubre su costo y margen.'],
        ['numbers', 'Saber cómo va mi mes', 'Registra ventas y un gasto para empezar a ver tus resultados.'],
      ] as const).map(([id, title, detail]) => <label key={id} className={`goal-choice ${value === id ? 'is-selected' : ''}`}>
        <input type="radio" name="onboarding-goal" value={id} checked={value === id} onChange={() => onChange(id)} />
        <span><strong>{title}</strong><small>{detail}</small></span>
      </label>)}
    </div>
  </fieldset>;
}
